import { Calendar } from "lucide-react";

import type { CallWithExtras } from "../../../types/call";

import { Card } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Table, TableBody } from "@/components/ui/table";
import { CallListItem } from "./CallListItem";

export interface CallListProps {
  calls: CallWithExtras[];
  deleteCall: (id: string) => void;
  selectCall: (id: string) => void;
}

export const CallList = ({
  deleteCall,
  selectCall,
  calls,
}: Readonly<CallListProps>) => {
  if (calls.length === 0) {
    return (
      <Card className="flex h-full w-full flex-grow flex-col items-center justify-center p-6 text-center select-none">
        <Calendar className="mb-2 h-12 w-12 text-gray-300" />
        <h3 className="text-lg font-medium">No calls yet</h3>
        <p className="text-sm text-gray-500">
          Start a new call to see it listed here
        </p>
      </Card>
    );
  }

  return (
    <Card className="flex h-full w-full flex-grow flex-col">
      <ScrollArea className="h-full w-full">
        <Table className="table-fixed">
          <TableBody>
            {calls.map((call) => (
              <CallListItem
                key={call.id}
                call={call}
                selectCall={selectCall}
                deleteCall={deleteCall}
              />
            ))}
          </TableBody>
        </Table>
      </ScrollArea>
    </Card>
  );
};
